import {OrderData, LineItem, LineItemState} from "../dtos/orderResponse"

export const isFullyShippedOrder = (order: OrderData): boolean => {
	const fullyShipped = order.lineItems.reduce(orderShippedReducer, true)
	return fullyShipped
}

const orderShippedReducer = (accumulator: boolean, current: LineItem) => {
	if (accumulator) return isFullyShippedItem(current)
	return accumulator
}

export const isFullyShippedItem = (lineItem: LineItem): boolean => {
	const shippedQuantity = lineItem.states.reduce(itemShippedReducer, 0)
	return shippedQuantity === lineItem.quantity
}

const itemShippedReducer = (accumulator: number, current: LineItemState) => {
	if (current.state.toLowerCase() === "shipped") return current.quantity + accumulator
	return accumulator
}
export function isCancelledItem(lineItem: LineItem): boolean {
	return ["Cancelled", "CancelRequested", "CancelSuccess"].includes(lineItem.states[0].state)
		? true
		: false
}
export function isCancelledOrder(order: OrderData): boolean {
	return order.lineItems.reduce(
		(accumulator, currentValue) => accumulator && isCancelledItem(currentValue) === true,
		true
	)
}
export function isOrderCancellable(order: OrderData): boolean {
	return order.lineItems.reduce(
		(accumulator, currentValue) => accumulator && currentValue.isCancellable === true,
		true
	)
}
